export const defaultLocale = 'en'
export const locales = [
    {
        code: 'en',
        name: 'english'
    },
    {
        code: 'de',
        name: 'german'
    },
    {
        code: 'hr',
        name: 'croatian'
    },
]


// WEBPACK FOOTER //
// ./src/config/i18n.js